


























































































































































































































import {
  defineComponent,
  SetupContext,
  PropType,
  ref,
} from '@nuxtjs/composition-api';
import {
  Article,
  LikeType,
  CorporationMember,
} from '~/graphql/graphqlOperations';
// import { useScroll } from '~/compositions/useScroll';
export default defineComponent({
  props: {
    article: {
      type: Object as PropType<Article>,
      required: true,
    },
    member: {
      type: Object as PropType<CorporationMember>,
      required: true,
    },
  },
  setup(props, context: SetupContext) {
    // モーダル表示フラグ
    const showForm = ref(false);
    const like = ref(!!props.article.like);

    // モーダルを閉じた時にリロードする処理(いいねの状態を反映するため)
    // 本来はいいねを押した時にreloadを走らせるのが正しいが、モーダルが閉じてしまうため。
    const closeEventHandler = () => {
      context.emit('reload');
    };

    // モーダルの閉じるボタンを押した時の処理
    const closeModal = () => {
      showForm.value = false;
      closeEventHandler();
    };
    /*
     * TODO:scroll-areaの高さ内に収まらない場合スクロール出来ることを示唆するため、表示されている最後の行を薄くしたい
     * そして、スクロールが最下部までいくと薄くする処理を無くしたい。
     */

    // // スクロールエリアの要素(再開するときはtemplateの#scroll-areaにref="scrollAreaRef"をつける)
    // //  @ts-ignore TODO: 一旦こうしておくけど後でちゃんとやる
    // const scrollAreaRef = ref<HTMLDivElement>(null);
    // // 要素の高さ(表示されている部分)
    // const contentHeight = ref(0);
    // // 要素の高さ(スクロールを合わせた高さ)
    // const scrollHeight = ref(0);
    // // スクロール位置
    // const scrollY = ref(0);

    // モーダルが開いた時に行う処理。スクロールDOMを取得する
    const openModal = () => {
      // モーダルを開くためにshowFormをtrueに。
      showForm.value = true;
      //   /*
      //    * モーダル内のDOMは、モーダルを開いたあとに形成される。
      //    * つまり、DOMが形成されてからでないと,
      //    * DOM(crollAreaRef.value)を取得できずエラーになるの。
      //    * (scrollAreaRefがnullなのでCannot read property 'clientHeight' of null")
      //    * 対応策として、モーダルを開く処理の中に、モーダルのDOMを取得する処理を入れている。
      //    */
      //   nextTick(() => {
      //     contentHeight.value = scrollAreaRef.value.clientHeight;
      //     scrollHeight.value = scrollAreaRef.value.scrollHeight;

      //     // これでスクロールした量を取得できる。
      //     scrollAreaRef.value.onscroll = () => {
      //       scrollY.value = scrollAreaRef.value.scrollTop;
      //       // 動かすたびに値が変化する。
      //       console.warn('scroll', scrollY.value);
      //       if (contentHeight.value < scrollHeight.value) {
      //         console.log('下の方に薄くする処理をCSSを追加');
      //         // スクロールが一番下に来た場合(以下の計算でスクロールが一番下に来たことがわかるらしい？)
      //         if (scrollHeight.value - scrollY.value === contentHeight.value)
      //           console.log(
      //             'スクロールが一番下まで来たら上記で追加したCSSをはずす'
      //           );
      //       }
      //     };
      //     const y = window.scrollY;
      //     console.warn('y', y);
      //     // scroll-areaで表設定されている高さより内容がある場合
      //     // scrollAreaRefをスクロール感知及び処理。
      //     // scrollAreaRef.value.addEventListener('scroll', test);
      //   });
    };
    // const test = () => {
    //   console.log('スクロ-ルしてるよ');
    // };
    return {
      showForm,
      like,
      LikeType,
      closeModal,
      closeEventHandler,
      openModal,
      // scrollAreaRef,
    };
  },
});
